var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 59,
    height: 60,
    viewBox: "0 0 59 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.08 -6.599)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.08 6.599)",
    fill: "none",
    stroke: "#e52431",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 29.5,
    cy: 30,
    rx: 29.5,
    ry: 30,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 29.5,
    cy: 30,
    rx: 28,
    ry: 28.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M21.654-19.332a.625.625,0,0,1,.459.189.625.625,0,0,1,.189.459v3.456a.625.625,0,0,1-.189.459.625.625,0,0,1-.459.189H14.526a.239.239,0,0,0-.27.27v7.128a.625.625,0,0,1-.189.459.625.625,0,0,1-.459.189H10.152a.625.625,0,0,1-.459-.189A.625.625,0,0,1,9.5-7.182V-14.31a.239.239,0,0,0-.27-.27H2.106a.625.625,0,0,1-.459-.189.625.625,0,0,1-.189-.459v-3.456a.625.625,0,0,1,.189-.459.625.625,0,0,1,.459-.189H9.234a.239.239,0,0,0,.27-.27V-26.73a.625.625,0,0,1,.189-.459.625.625,0,0,1,.459-.189h3.456a.625.625,0,0,1,.459.189.625.625,0,0,1,.189.459V-19.6a.239.239,0,0,0,.27.27Z",
    transform: "translate(17.08 53.599)",
    fill: "#212121"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg4);
export default __webpack_public_path__ + "static/media/4.64bcf7897e5dec54421529b235656018.svg";
export { ForwardRef as ReactComponent };